<!-- 搜索结果 - 图片结果 -->

<template>
  <div class="clearFloat" :class="{'image-wrap':isShowAll}">
    <!-- <p> 真相为您找到相关结果{{ results.page.total }}个 </p> -->
    <section class="imgResult">
      <div :class="{singleImgBox:true}" v-lazy="img.imgObj" :data-id="img.imgID" v-for="(img,index) in getAllItems" :style="{width: img.width * 180 / img.height + 'px', flexGrow: img.width * 180 / img.height}">
        <img v-lazy="img.imgObj" class="imgConBox" @click="openPage(img.webUrl)"/>
        <div class="imgInfoBox">
          <span class="imgText" v-html="img.webTitleFormat"></span>
          <span class="imgText">{{img.webUrl}}</span>
          <a class="imgNotSave saveBtn" v-if="!img.hasAction">{{img.statusDesc}}</a>
          <a class="imgIsSave saveBtn" v-if="img.hasAction" @click="saveEvidence(index)">存证</a>
        </div>
      </div>
    </section>
    <p class="tips-show-all" v-if="isShowAll">~ 别拉了，到底啦 ~</p>
    <transition name="fade">
      <div class="back_top" v-if="isShowBackTop">
        <img src="../../assets/search/back_top_2.png"
             v-if="backTopIsHover"
             @mouseout="backTopOut"
             @click="backTop">
        <img src="../../assets/search/back_top_1.png"
             v-else
             @mouseover="backTopOver">
      </div>
    </transition>
  </div>
</template>

<script>

  import Vue from 'vue'
  import VueLazyload from 'vue-lazyload'

  //图片懒加载
  Vue.use(VueLazyload);
  // Vue.use(VueLazyload,{
  //   error: require('../../assets/imgRes/error.png'),
  //   loading: require('../../assets/imgRes/loading2.gif'),
  //   listenEvents: [ 'scroll' ],
  //   preLoad: 1.3,
  //   attempt: 1
  // })
  // 子组件与父组件通讯
  export default {
    name: 'imageResults',
    props: ['results'],
    mounted () {
      this.init();
    },
    data () {
      return {
        list: [],
        imgItems: [],
        num: 1,
        loading: false,
        getAllItems:[],
        isShowAll:false,
        backTopIsHover:false,
        isShowBackTop:false
      }
    },
    methods: {
      init(){
        // //判断滚动条位置
        this.isShowAll = false;
        this.loading = true;
        this.list = [];
        this.getData();
      },
      getData () {
        let that = this;

        $(window).scroll(function(){
          let height = $(window).height();
          if ($(window).scrollTop()>height){
            that.isShowBackTop = true;
          }else{
            that.isShowBackTop = false;
          }
          var isBottom = $(document).scrollTop() >= ($(document).height() - $(window).height());
          if (!that.loading && isBottom) {
            that.loading = true;
            let query = that.$router.history.current.query;
            let path = that.$router.history.current.path;
            let newQuery = {};
            for(let key in query){
              if(key == 'pageNum'){
                newQuery[key] = parseInt(query[key]) + 1 ;
              }else{
                newQuery[key] = query[key];
              }
            }
            if(newQuery.pageNum<=Math.ceil(that.results.page.totalRow/50)){
              that.isShowAll = false;
              that.$router.push({path, query:newQuery});
            }else{
              console.log('数据加载完毕')
              that.isShowAll = true;
            }
//          that.$emit('gotoPage',that.num);
          }
        });
      },
      getID (imgID) {
        // console.log(imgID)
      },
      saveEvidence(id){
        this.$emit('savingEvidence', id);
      },
      // getData(){
      // 	this.num++;
      // 	this.$emit('gotoPage', this.num);
      // },
      openPage(url){
        window.open(url);
      },
      backTopOver () {
        this.backTopIsHover = true;
      },
      backTopOut () {
        this.backTopIsHover = false;
      },
      backTop () {
        $(window).scrollTop(()=>{
          $('body,html').animate({ scrollTop: 0 });
      });
      }
    },
    computed: {
// 		getAllItems(){
// //		  console.log('this.results.data: ', this.results.data);
// 			let data = this.results.data;
// 			for(let key in data){
// 				this.list.push(data[key]);
// 			}
// 			this.loading = false;
// //      console.log('this.list: ', this.list);
// 			return this.list;
// 		}
    },
    watch: {
      '$route' (to, from) {
        //刷新参数放到这里里面去触发就可以刷新相同界面了
        // $(window).off('scroll');
        if(to.query.pageNum == 1){
          this.list = [];
        }
//      this.init();
      },
      'results.data' () {
        let data = this.results.data;
        for(let key in data){
          this.list.push(data[key]);
        }
        this.loading = false;
        this.getAllItems = this.list;
      }
    },
    beforeRouteLeave (to, from, next) {
      $(window).off('scroll');
      next();
    }
  }
</script>

<style scoped>
  /*  reset style */
  a{
    text-decoration: none;
    color: #000;
  }
  img{
    border:0;
  }
  .image-wrap{
    position: relative;
    padding-bottom: 55px;
  }
  /* clear float style */
  .clearFloat:after{
    content: '.';
    height: 0;
    overflow: hidden;
    clear: both;
    visibility: hidden;
    display: block;
    cursor: pointer;
  }
  /* image results style */
  .singleImgBox{
    height: 180px;
    margin:0 3px 6px;
    float: left;
    position: relative;
    cursor: pointer;
    flex-grow: 1;
  }
  .singleImgBox:hover .imgInfoBox{
    opacity: 1;
  }
  .imgConBox{
    min-width: 100%;
    max-width: 100%;
    height: 180px;
    vertical-align: bottom;
    object-fit: cover;
  }
  .imgInfoBox{
    background-color:rgb(0,0,0);
    height:40px;
    color:#fff;
    width:100%;
    position:absolute;
    left:0;
    bottom:0;
    padding:4px 3px 6px 7px;
    box-sizing:border-box;
    opacity: 0.7;
  }
  .imgInfoBox .imgText{
    display:block;
    font-size:12px;
    text-align:left;
    max-width: 70%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .imgInfoBox .imgIsSave{
    background-color:#A12935;
  }
  .imgInfoBox .imgNotSave{
    background-color:#959595;
    cursor: not-allowed;
  }
  .imgInfoBox .saveBtn{
    display:block;
    position:absolute;
    right:3px;
    bottom:3px;
    color:#fff;
    text-decoration:none;
    font-size:11px;
    padding:2px 4px;
    border-radius: 2px;
  }
  img[lazy=error] {
    display: none!important;
  }
  div[lazy=error]{
    display: none!important;
  }
  p.tips-show-all{
    font-size: 16px;
    position: absolute;
    bottom: 10px;
    color:#666;
    text-align: center;
    width: 100%;
  }
  .back_top{
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 36px;
    height: 36px;
  }
  /*transition Start*/
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-active {
    /*transition: 1s;*/
    opacity: 0;
  }
  /*transition End*/

  /* se */
  .imgResult {
    padding: 2px;
    display: flex;
    flex-wrap: wrap;
  }
  .imgResult::after {
    content: '';
    flex-grow: 999999999;
  }
  .singleImgBox:nth-last-child(5),
  .singleImgBox:nth-last-child(4),
  .singleImgBox:nth-last-child(3),
  .singleImgBox:nth-last-child(2),
  .singleImgBox:nth-last-child(1) {
    flex-grow: 0;
  }
</style>



// WEBPACK FOOTER //
// ImageResults.vue?8be552de